import React from "react";

interface PropertyCardProps {
  children: React.ReactNode;
  className?: string;
}

export const PropertyCard: React.FC<PropertyCardProps> = ({
  children,
  className = "",
}) => {
  return <div className={`bg-white rounded-xl ${className}`}>{children}</div>;
};

export default PropertyCard;
